/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  CreateDemoCohortRequest,
  CreateDemoCohortResponse,
  CreateDemoCommunityAnnouncementRequest,
  CreateDemoCommunityAnnouncementResponse,
  CreateDemoCommunityWinResponse,
  CreateDemoEventRequest,
  CreateDemoEventResponse,
  CreateDemoFundingOpportunityResponse,
  CreateDemoJobPostingResponse,
  CreateDemoMatchRequest,
  CreateDemoMatchResponse,
  CreateDemoOrganizationRequest,
  CreateDemoOrganizationResponse,
  CreateDemoProjectRequest,
  CreateDemoProjectResponse,
  CreateDemoTeamMatchRequest,
  CreateDemoTeamMatchResponse,
  CreateDemoUserRequest,
  CreateDemoUserResponse,
  HTTPValidationError,
} from './platformapi.schemas';

import createDemoCohortMutator from '../custom-axios-instance';
import createDemoCommunityAnnouncementMutator from '../custom-axios-instance';
import createDemoCommunityWinMutator from '../custom-axios-instance';
import createDemoEventMutator from '../custom-axios-instance';
import createDemoFundingOpportunityMutator from '../custom-axios-instance';
import createDemoIndividualMatchMutator from '../custom-axios-instance';
import createDemoJobPostingMutator from '../custom-axios-instance';
import createDemoOrganizationMutator from '../custom-axios-instance';
import createDemoProjectMutator from '../custom-axios-instance';
import createDemoTeamMatchMutator from '../custom-axios-instance';
import createDemoUserMutator from '../custom-axios-instance';

/**
 * Creates a demo cohort with realistic placeholder details, ready to attach
demo professionals or teams to.
 * @summary Create Demo Cohort
 */
export const createDemoCohort = (
  createDemoCohortRequest: CreateDemoCohortRequest,
  signal?: AbortSignal,
) => {
  return createDemoCohortMutator<CreateDemoCohortResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/demo-data/create-cohort`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createDemoCohortRequest,
    signal,
  });
};

export const getCreateDemoCohortMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDemoCohort>>,
    TError,
    { data: CreateDemoCohortRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDemoCohort>>,
  TError,
  { data: CreateDemoCohortRequest },
  TContext
> => {
  const mutationKey = ['createDemoCohort'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDemoCohort>>,
    { data: CreateDemoCohortRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createDemoCohort(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDemoCohortMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDemoCohort>>
>;
export type CreateDemoCohortMutationBody = CreateDemoCohortRequest;
export type CreateDemoCohortMutationError = void | HTTPValidationError;

/**
 * @summary Create Demo Cohort
 */
export const useCreateDemoCohort = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDemoCohort>>,
      TError,
      { data: CreateDemoCohortRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDemoCohort>>,
  TError,
  { data: CreateDemoCohortRequest },
  TContext
> => {
  const mutationOptions = getCreateDemoCohortMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a demo community announcement, for building demo scenarios. The
community page shows reps an "organization" announcement and pros a
"professional" one (see CommunityHomePage.tsx), so the type has to be
picked rather than randomized independently of the pool it draws from.
 * @summary Create Demo Community Announcement
 */
export const createDemoCommunityAnnouncement = (
  createDemoCommunityAnnouncementRequest: CreateDemoCommunityAnnouncementRequest,
  signal?: AbortSignal,
) => {
  return createDemoCommunityAnnouncementMutator<CreateDemoCommunityAnnouncementResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/demo-data/create-community-announcement`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createDemoCommunityAnnouncementRequest,
    signal,
  });
};

export const getCreateDemoCommunityAnnouncementMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDemoCommunityAnnouncement>>,
    TError,
    { data: CreateDemoCommunityAnnouncementRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDemoCommunityAnnouncement>>,
  TError,
  { data: CreateDemoCommunityAnnouncementRequest },
  TContext
> => {
  const mutationKey = ['createDemoCommunityAnnouncement'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDemoCommunityAnnouncement>>,
    { data: CreateDemoCommunityAnnouncementRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createDemoCommunityAnnouncement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDemoCommunityAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDemoCommunityAnnouncement>>
>;
export type CreateDemoCommunityAnnouncementMutationBody = CreateDemoCommunityAnnouncementRequest;
export type CreateDemoCommunityAnnouncementMutationError = void | HTTPValidationError;

/**
 * @summary Create Demo Community Announcement
 */
export const useCreateDemoCommunityAnnouncement = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDemoCommunityAnnouncement>>,
      TError,
      { data: CreateDemoCommunityAnnouncementRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDemoCommunityAnnouncement>>,
  TError,
  { data: CreateDemoCommunityAnnouncementRequest },
  TContext
> => {
  const mutationOptions = getCreateDemoCommunityAnnouncementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a demo community win, for building demo scenarios.
 * @summary Create Demo Community Win
 */
export const createDemoCommunityWin = (signal?: AbortSignal) => {
  return createDemoCommunityWinMutator<CreateDemoCommunityWinResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/demo-data/create-community-win`,
    method: 'POST',
    signal,
  });
};

export const getCreateDemoCommunityWinMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDemoCommunityWin>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDemoCommunityWin>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['createDemoCommunityWin'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDemoCommunityWin>>,
    void
  > = () => {
    return createDemoCommunityWin();
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDemoCommunityWinMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDemoCommunityWin>>
>;

export type CreateDemoCommunityWinMutationError = void | HTTPValidationError;

/**
 * @summary Create Demo Community Win
 */
export const useCreateDemoCommunityWin = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDemoCommunityWin>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDemoCommunityWin>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getCreateDemoCommunityWinMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a demo community event, for building demo scenarios.
 * @summary Create Demo Event
 */
export const createDemoEvent = (
  createDemoEventRequest: CreateDemoEventRequest,
  signal?: AbortSignal,
) => {
  return createDemoEventMutator<CreateDemoEventResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/demo-data/create-event`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createDemoEventRequest,
    signal,
  });
};

export const getCreateDemoEventMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDemoEvent>>,
    TError,
    { data: CreateDemoEventRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDemoEvent>>,
  TError,
  { data: CreateDemoEventRequest },
  TContext
> => {
  const mutationKey = ['createDemoEvent'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDemoEvent>>,
    { data: CreateDemoEventRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createDemoEvent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDemoEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDemoEvent>>
>;
export type CreateDemoEventMutationBody = CreateDemoEventRequest;
export type CreateDemoEventMutationError = void | HTTPValidationError;

/**
 * @summary Create Demo Event
 */
export const useCreateDemoEvent = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDemoEvent>>,
      TError,
      { data: CreateDemoEventRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDemoEvent>>,
  TError,
  { data: CreateDemoEventRequest },
  TContext
> => {
  const mutationOptions = getCreateDemoEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a demo funding opportunity, for building demo scenarios.
 * @summary Create Demo Funding Opportunity
 */
export const createDemoFundingOpportunity = (signal?: AbortSignal) => {
  return createDemoFundingOpportunityMutator<CreateDemoFundingOpportunityResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/demo-data/create-funding-opportunity`,
    method: 'POST',
    signal,
  });
};

export const getCreateDemoFundingOpportunityMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDemoFundingOpportunity>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDemoFundingOpportunity>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['createDemoFundingOpportunity'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDemoFundingOpportunity>>,
    void
  > = () => {
    return createDemoFundingOpportunity();
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDemoFundingOpportunityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDemoFundingOpportunity>>
>;

export type CreateDemoFundingOpportunityMutationError = void | HTTPValidationError;

/**
 * @summary Create Demo Funding Opportunity
 */
export const useCreateDemoFundingOpportunity = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDemoFundingOpportunity>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDemoFundingOpportunity>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getCreateDemoFundingOpportunityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Fully matches an existing professional to an existing project, for building
demo scenarios. A real match spans three tables that different parts of the
UI read from independently — Introductions, AssignmentDiscoveries, and
Assignments (see admin_introductions.py's update_my_project_status for how
much branching is needed to move an *existing* record between states).
We don't need any of that here since we're always creating fresh rows, not
transitioning existing ones — so we just insert one of each, already in
their final accepted/matched state. Does not send any notification emails.
 * @summary Create Demo Individual Match
 */
export const createDemoIndividualMatch = (
  createDemoMatchRequest: CreateDemoMatchRequest,
  signal?: AbortSignal,
) => {
  return createDemoIndividualMatchMutator<CreateDemoMatchResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/demo-data/create-individual-match`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createDemoMatchRequest,
    signal,
  });
};

export const getCreateDemoIndividualMatchMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDemoIndividualMatch>>,
    TError,
    { data: CreateDemoMatchRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDemoIndividualMatch>>,
  TError,
  { data: CreateDemoMatchRequest },
  TContext
> => {
  const mutationKey = ['createDemoIndividualMatch'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDemoIndividualMatch>>,
    { data: CreateDemoMatchRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createDemoIndividualMatch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDemoIndividualMatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDemoIndividualMatch>>
>;
export type CreateDemoIndividualMatchMutationBody = CreateDemoMatchRequest;
export type CreateDemoIndividualMatchMutationError = void | HTTPValidationError;

/**
 * @summary Create Demo Individual Match
 */
export const useCreateDemoIndividualMatch = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDemoIndividualMatch>>,
      TError,
      { data: CreateDemoMatchRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDemoIndividualMatch>>,
  TError,
  { data: CreateDemoMatchRequest },
  TContext
> => {
  const mutationOptions = getCreateDemoIndividualMatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a demo job posting, for building demo scenarios.
 * @summary Create Demo Job Posting
 */
export const createDemoJobPosting = (signal?: AbortSignal) => {
  return createDemoJobPostingMutator<CreateDemoJobPostingResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/demo-data/create-job-posting`,
    method: 'POST',
    signal,
  });
};

export const getCreateDemoJobPostingMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDemoJobPosting>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDemoJobPosting>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['createDemoJobPosting'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDemoJobPosting>>,
    void
  > = () => {
    return createDemoJobPosting();
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDemoJobPostingMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDemoJobPosting>>
>;

export type CreateDemoJobPostingMutationError = void | HTTPValidationError;

/**
 * @summary Create Demo Job Posting
 */
export const useCreateDemoJobPosting = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDemoJobPosting>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof createDemoJobPosting>>, TError, void, TContext> => {
  const mutationOptions = getCreateDemoJobPostingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a demo organization with an attached representative user, ready to
be used for a demo project.
 * @summary Create Demo Organization
 */
export const createDemoOrganization = (
  createDemoOrganizationRequest: CreateDemoOrganizationRequest,
  signal?: AbortSignal,
) => {
  return createDemoOrganizationMutator<CreateDemoOrganizationResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/demo-data/create-organization`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createDemoOrganizationRequest,
    signal,
  });
};

export const getCreateDemoOrganizationMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDemoOrganization>>,
    TError,
    { data: CreateDemoOrganizationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDemoOrganization>>,
  TError,
  { data: CreateDemoOrganizationRequest },
  TContext
> => {
  const mutationKey = ['createDemoOrganization'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDemoOrganization>>,
    { data: CreateDemoOrganizationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createDemoOrganization(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDemoOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDemoOrganization>>
>;
export type CreateDemoOrganizationMutationBody = CreateDemoOrganizationRequest;
export type CreateDemoOrganizationMutationError = void | HTTPValidationError;

/**
 * @summary Create Demo Organization
 */
export const useCreateDemoOrganization = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDemoOrganization>>,
      TError,
      { data: CreateDemoOrganizationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDemoOrganization>>,
  TError,
  { data: CreateDemoOrganizationRequest },
  TContext
> => {
  const mutationOptions = getCreateDemoOrganizationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a demo project for an existing representative, with realistic
placeholder skills/description, for building demo scenarios. The
organization is derived from the representative rather than taken as a
separate input, so it's impossible to pass a rep/org pair that don't
actually belong together.
 * @summary Create Demo Project
 */
export const createDemoProject = (
  createDemoProjectRequest: CreateDemoProjectRequest,
  signal?: AbortSignal,
) => {
  return createDemoProjectMutator<CreateDemoProjectResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/demo-data/create-project`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createDemoProjectRequest,
    signal,
  });
};

export const getCreateDemoProjectMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDemoProject>>,
    TError,
    { data: CreateDemoProjectRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDemoProject>>,
  TError,
  { data: CreateDemoProjectRequest },
  TContext
> => {
  const mutationKey = ['createDemoProject'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDemoProject>>,
    { data: CreateDemoProjectRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createDemoProject(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDemoProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDemoProject>>
>;
export type CreateDemoProjectMutationBody = CreateDemoProjectRequest;
export type CreateDemoProjectMutationError = void | HTTPValidationError;

/**
 * @summary Create Demo Project
 */
export const useCreateDemoProject = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDemoProject>>,
      TError,
      { data: CreateDemoProjectRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDemoProject>>,
  TError,
  { data: CreateDemoProjectRequest },
  TContext
> => {
  const mutationOptions = getCreateDemoProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a full demo team match for building demo scenarios: a handful of
fresh, already-approved demo professionals in the given cohort (or the
evergreen cohort if none given), a team made up of those professionals,
and a matched assignment of that team to the given project. Only a project
id is required — team members are always created fresh here rather than
picked from existing users, so there's no way to end up with a team whose
members don't actually belong to the team's cohort. Does not send any
notification emails.
 * @summary Create Demo Team Match
 */
export const createDemoTeamMatch = (
  createDemoTeamMatchRequest: CreateDemoTeamMatchRequest,
  signal?: AbortSignal,
) => {
  return createDemoTeamMatchMutator<CreateDemoTeamMatchResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/demo-data/create-team-match`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createDemoTeamMatchRequest,
    signal,
  });
};

export const getCreateDemoTeamMatchMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDemoTeamMatch>>,
    TError,
    { data: CreateDemoTeamMatchRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDemoTeamMatch>>,
  TError,
  { data: CreateDemoTeamMatchRequest },
  TContext
> => {
  const mutationKey = ['createDemoTeamMatch'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDemoTeamMatch>>,
    { data: CreateDemoTeamMatchRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createDemoTeamMatch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDemoTeamMatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDemoTeamMatch>>
>;
export type CreateDemoTeamMatchMutationBody = CreateDemoTeamMatchRequest;
export type CreateDemoTeamMatchMutationError = void | HTTPValidationError;

/**
 * @summary Create Demo Team Match
 */
export const useCreateDemoTeamMatch = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDemoTeamMatch>>,
      TError,
      { data: CreateDemoTeamMatchRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDemoTeamMatch>>,
  TError,
  { data: CreateDemoTeamMatchRequest },
  TContext
> => {
  const mutationOptions = getCreateDemoTeamMatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a demo user (professional, representative, or admin) with realistic
placeholder data, for building demo scenarios.
 * @summary Create Demo User
 */
export const createDemoUser = (
  createDemoUserRequest: CreateDemoUserRequest,
  signal?: AbortSignal,
) => {
  return createDemoUserMutator<CreateDemoUserResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/demo-data/create-user`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createDemoUserRequest,
    signal,
  });
};

export const getCreateDemoUserMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDemoUser>>,
    TError,
    { data: CreateDemoUserRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDemoUser>>,
  TError,
  { data: CreateDemoUserRequest },
  TContext
> => {
  const mutationKey = ['createDemoUser'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDemoUser>>,
    { data: CreateDemoUserRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createDemoUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDemoUserMutationResult = NonNullable<Awaited<ReturnType<typeof createDemoUser>>>;
export type CreateDemoUserMutationBody = CreateDemoUserRequest;
export type CreateDemoUserMutationError = void | HTTPValidationError;

/**
 * @summary Create Demo User
 */
export const useCreateDemoUser = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDemoUser>>,
      TError,
      { data: CreateDemoUserRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDemoUser>>,
  TError,
  { data: CreateDemoUserRequest },
  TContext
> => {
  const mutationOptions = getCreateDemoUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
